import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const Retrieve: React.FC = () => {
  return (
    <PageTemplate
      title="Retrieve"
      description="Retrieve metadata from your Salesforce org"
    />
  );
};